// Shared helpers for keyboard handlers.

// True when the event target is an editable text surface, where a global
// shortcut handler must NOT steal the keystroke. Every document-level keydown
// handler should guard with this before acting.
export function isTypingTarget(target) {
  if (!target) return false;
  const tag = target.tagName;
  return tag === "INPUT" || tag === "TEXTAREA" || target.isContentEditable === true;
}

// True when a react-bootstrap <Nav> onSelect fired from its own arrow-key traversal rather than from
// a click. AbstractNav owns ArrowLeft/Right/Up/Down over a role="tablist" strip: it finds the next
// enabled tab, preventDefault()s the keystroke and reports the target through onSelect
// (AbstractNav.js:80-104). Clicks arrive through the same callback (AbstractNavItem.js:68-73).
//
// A strip whose tabs are router <Link>s therefore MUST supply onSelect — without one the keystroke is
// still swallowed, so arrow keys neither move between tabs nor scroll the page — and it MUST act on
// keyboard events only, or a click navigates twice: once via the Link, once via the handler.
export function isNavKeyboardSelect(event) {
  return !!event && event.type === "keydown";
}
